import { compose, hoistStatics, lifecycle, withState, withHandlers, withProps, defaultProps, withPropsOnChange } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import Grid from './Grid';
import WithLoading from '../../WithLoading';
import { gridActions } from '../../../reducers/grid';
import gh from '../../../helpers/grid.helper';
import ph from './grid.helper';
import columnTypes from './columnTypes';

const updateData = async (props, criteria) => {
  const { setNoItemsGrid, setIsLoading, changeCountRecordList, setCount, setData, service, t, callbackError, initialErrorMessage, id } = props;
  // setIsLoading(true);
  const nextCriteria = criteria || props.criteria;
  const { data, count } = await service.getData(nextCriteria);
  if (changeCountRecordList) changeCountRecordList(count)
  setCount(count);
  setData(data);
  const fileredCriteria = Object.keys(nextCriteria).filter(key => nextCriteria[key]);
  if (id === 'feedback' && nextCriteria.status) {
    fileredCriteria.push('search');
  }
  if (fileredCriteria.includes('search') && !count) {
    if (callbackError) callbackError({ status: true, type: gh.ERROR_GRID_SEARCH });
    setNoItemsGrid(t('Your search did not match any item'));
  } else if (!count) {
    if (callbackError) callbackError({ status: true, type: gh.ERROR_GRID_INITIAL });
    setNoItemsGrid(initialErrorMessage || t('Nothing to show'));
  } else {
    if (callbackError) callbackError({ status: false });
    setNoItemsGrid('');
  }
  // setIsLoading(false);
};

const updateUser = props => (e, type, item) => {
  if (type !== columnTypes.SELECT && props.callbackToSetUser) {
    props.callbackToSetUser(e, item);
  }
};

const updateChecked = props => (index, value) => {
  const newCheckObject = { ...props.checked };
  if (index === -1) {
    // if it's checkbox in header (index = -1)
    for (let i = 0; i < props.data.length; i++) {
      newCheckObject[props.data[i].id] = value;
    }
  }
  newCheckObject[index] = value;
  props.setChecked(newCheckObject);
};

const goToPage = props => async (nextPage) => {
  const page = nextPage > -1 ? nextPage : 0;
  const criteria = {
    ...props.criteria,
    page,
  };
  await updateData(props, criteria);
  await props.setCriteria(criteria);
};

const changePageSize = props => async (limit) => {
  const criteria = {
    ...props.criteria,
    limit,
    page: 0,
  };
  props.setCriteria(criteria);
  await updateData(props, criteria);
};


const sort = props => async ({ order, sortBy }) => {
  if (props.timer) {
    clearTimeout(props.timer);
    props.setTimer(false);
  }
  const criteria = {
    ...props.criteria,
    order,
    sortBy,
  };
  props.setCriteria(criteria);
  await updateData(props, criteria);
};

const search = async (props, searchPhrase) => {
  if (props.timer) {
    clearTimeout(props.timer);
    props.setTimer(false);
  }
  const criteria = {
    ...props.criteria,
    page: 0,
  };
  criteria[searchPhrase.title] = searchPhrase.value;
  await props.setCriteria(criteria);
  await updateData(props, criteria);
};


const defaultCriteria = {
  limit: 10,
  page: 0,
  order: 'asc',
};


const compare2Criteria = (criteria1, criteria2) => {
  if (!criteria2) return true;
  for (const param of Object.keys(criteria2)) {
    if (param !== 'page') {
      if (criteria1[param] !== criteria2[param]) {
        if (
          !((criteria1[param] === '' || typeof criteria1[param] === 'undefined')
            && (criteria2[param] === '' || typeof criteria2[param] === 'undefined'))
          && !(typeof criteria2[param] === 'object' && criteria2[param].length === 0)
          && !(typeof criteria2[param] === 'object' && criteria2[param].value === '' && criteria2[param].label === '-')
        ) return false;
      }
    }
  }
  return true;
};

const destroyItemCallback = (props, id) => () => async () => {
  props.setShowConfirm(false);
  await props.service.destroy(id);
  const { count, criteria: { limit, page } } = props;
  const countPages = ph.getPageCount(count, limit);
  if (page === countPages - 1 && countPages !== ph.getPageCount(count - 1, limit)) {
    goToPage(props)(props.criteria.page - 1);
  } else {
    updateData(props, false);
  }
};

const destroyItem = props => async (id) => {
  await props.setConfirmCallback(destroyItemCallback(props, id));
  await props.setShowConfirm(true);
};

const defaultConfirmCallback = () => () => { console.log('confirm'); };

const mapStateToProps = state => ({
  allCriteria: state.grid.criteria,
});

const mapDispatchToProps = {
  updateCriteriaById: gridActions.updateCriteria,
  removeCriteriaById: gridActions.removeCriteria,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  defaultProps({
    timeout: 200,
    updateDataFlag: false,
    showFilter: true,
    showHeader: true,
  }),
  withState('timer', 'setTimer', false),
  withState('data', 'setData', []),
  withState('count', 'setCount', 0),
  withState('isLoading', 'setIsLoading', true),
  withState('showConfirm', 'setShowConfirm', false),
  withState('confirmCallback', 'setConfirmCallback', defaultConfirmCallback),
  withState('noItemsGrid', 'setNoItemsGrid', ''),
  withProps(props => ({
    positions: gh.getColumnPosition(props.columns),
    isDefaultCriteria: compare2Criteria({
      ...defaultCriteria,
      ...props.initCriteria,
    }, props.allCriteria[props.id]),
    removeCriteria: () => props.removeCriteriaById(props.id),
    setCriteria: data => props.updateCriteriaById({
      id: props.id,
      data,
    }),
    criteria: {
      ...defaultCriteria,
      ...props.initCriteria,
      ...props.allCriteria[props.id],
    },
    permissionToDelete: props.permissionToDelete,
  })),
  lifecycle({
    async componentDidMount() {
      if (!this.props.criteria || (this.props.saveFilter !== undefined && !this.props.saveFilter)) {
        let newCriteria = defaultCriteria;
        if (this.props.initCriteria) {
          newCriteria = {
            ...defaultCriteria,
            ...this.props.initCriteria,
          };
        }
        await this.props.setCriteria(newCriteria);
        await updateData(this.props, newCriteria);
      } else {
        await updateData(this.props, false);
      }
      await this.props.setIsLoading(false);
    },
    async componentWillUpdate(nextProps) {
      if (this.props.searchPhrase !== nextProps.searchPhrase) {
        await search(nextProps, nextProps.searchPhrase);
      }
      if (JSON.stringify(this.props.initCriteria) !== JSON.stringify(nextProps.initCriteria)) {
        updateData(nextProps, {
          ...nextProps.criteria,
          ...nextProps.initCriteria,
        });
        nextProps.updateCriteriaById({ id: nextProps.id,
          data: {
            ...nextProps.criteria,
            ...nextProps.initCriteria,
          } });
      }
    },
    async componentWillUnmount() {
      if (this.props.timer) {
        clearTimeout(this.props.timer);
      }
    },
  }),
  withHandlers({
    sort,
    goToPage,
    updateUser,
    destroyItem,
    updateChecked,
    changePageSize,
    updateData: props => async (criteria = false) => updateData(props, criteria),
  }),
  withPropsOnChange(['updateDataFlag', 'updated'], (props) => {
    if (!props.isLoading && props.updated && Object.keys(props.updated).length !== 0) {
      if (props.updated.page !== undefined) {
        goToPage({ ...props, criteria: props.updated.criteria || props.criteria })(props.updated.page);
      } else if (props.updated.removed !== undefined) {
        const pageCount = ph.getPageCount(
          props.count - props.updated.removed.length,
          props.criteria.limit,
        );
        if (pageCount <= props.criteria.page) {
          goToPage(props)(pageCount - 1);
        } else { goToPage(props)(props.criteria.page); }
      } else updateData(props);
      props.setUpdated({});
    } else if (!props.isLoading && props.updateDataFlag) {
      updateData(props);
    }
  }),
);

export default hoistStatics(enhance)(WithLoading(Grid));



// WEBPACK FOOTER //
// ./src/components/list/grid/index.js